import React, { FC }                from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Icon }             from "semantic-ui-react";
import RegisterCustomer             from "../../../application/usecase/customer/RegisterCustomer";
import Customer                     from "../../../domain/customer/Customer";
import { ResKaState }               from "../../../index";

const CustomerRegisterButton: FC = () => {
  const customer: Customer = useSelector((state: ResKaState) => state.customer);
  const registerCustomer: RegisterCustomer = new RegisterCustomer(useDispatch());
  return (
    <>
      <Button
        icon
        labelPosition="left"
        positive
        onClick={ () => registerCustomer.execute(customer) }
      >
        <Icon name="save"/>
        保存する
      </Button>
    </>
  );
};

export default CustomerRegisterButton;
